import { EXCLUDED_RUBRICS, IDictionaryDto, TRubricType } from '../interfaces/news';

const excludedRubricArray = Object.values<TRubricType>(EXCLUDED_RUBRICS);

export const checkOnExcludedRubric = (rubric: TRubricType | IDictionaryDto): TRubricType | IDictionaryDto | null => {
  if (!rubric) return null;
  if (typeof rubric === 'object') {
    return !excludedRubricArray.includes(rubric.value as TRubricType) ? rubric : null;
  }
  return !excludedRubricArray.includes(rubric) ? rubric : null;
};

export const checkIsExcludedRubric = (rubric: TRubricType | IDictionaryDto): boolean => {
  if (!rubric) return false;
  return !checkOnExcludedRubric(rubric);
};

export const removeExcludedRubrics = (rubrics: TRubricType[]) => {
  return rubrics.filter(checkOnExcludedRubric);
};
